export default __webpack_public_path__ + "static/media/calculationMethodology.63b7ff16.pdf";